import React, { useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { SectionEyebrow } from './ui/SectionEyebrow';
export function LeadForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setTimeout(() => setIsSubmitted(true), 800);
  };
  return <section id="contact" className="py-24 bg-iris-black border-t border-iris-border relative" data-id="element-165">
      <Container data-id="element-166">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-24" data-id="element-167">
          <div className="lg:col-span-7" data-id="element-168">
            <SectionEyebrow text="Schedule a Walkthrough" className="mb-4" data-id="element-169" />
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-8" data-id="element-170">
              REQUEST A WALKTHROUGH
            </h2>

            {isSubmitted ? <div className="bg-iris-surface border border-iris-green p-8 text-center" data-id="element-171">
                <CheckCircle2Icon className="w-16 h-16 text-iris-green mx-auto mb-6" data-id="element-172" />
                <h3 className="text-2xl font-display font-bold text-white mb-2" data-id="element-173">
                  REQUEST RECEIVED
                </h3>
                <p className="text-iris-muted mb-6" data-id="element-174">
                  Your walkthrough request has been securely logged. A member of
                  our team will contact you within 1 business day to confirm
                  your time.
                </p>
                <Button variant="secondary" onClick={() => setIsSubmitted(false)} data-id="element-175">
                  Submit Another Request
                </Button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-176">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-177">
                  <div className="space-y-2" data-id="element-178">
                    <label className="text-sm font-mono text-iris-text uppercase" data-id="element-179">
                      Full Name
                    </label>
                    <input required type="text" className="w-full bg-iris-surface border border-iris-border px-4 py-3 text-white focus:outline-none focus:border-iris-green focus:ring-1 focus:ring-iris-green transition-colors" data-id="element-180" />
                  </div>
                  <div className="space-y-2" data-id="element-181">
                    <label className="text-sm font-mono text-iris-text uppercase flex justify-between" data-id="element-182">
                      Work Email{' '}
                      <span className="text-iris-muted text-xs" data-id="element-183">
                        Gov/Agency preferred
                      </span>
                    </label>
                    <input required type="email" className="w-full bg-iris-surface border border-iris-border px-4 py-3 text-white focus:outline-none focus:border-iris-green focus:ring-1 focus:ring-iris-green transition-colors" data-id="element-184" />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-185">
                  <div className="space-y-2" data-id="element-186">
                    <label className="text-sm font-mono text-iris-text uppercase" data-id="element-187">
                      Agency / Organization
                    </label>
                    <input required type="text" className="w-full bg-iris-surface border border-iris-border px-4 py-3 text-white focus:outline-none focus:border-iris-green focus:ring-1 focus:ring-iris-green transition-colors" data-id="element-188" />
                  </div>
                  <div className="space-y-2" data-id="element-189">
                    <label className="text-sm font-mono text-iris-text uppercase" data-id="element-190">
                      Agency Type
                    </label>
                    <select required className="w-full bg-iris-surface border border-iris-border px-4 py-3 text-white focus:outline-none focus:border-iris-green focus:ring-1 focus:ring-iris-green transition-colors appearance-none" data-id="element-191">
                      <option value="" data-id="element-192">Select Type...</option>
                      <option value="local" data-id="element-193">Local Law Enforcement</option>
                      <option value="state" data-id="element-194">State Law Enforcement</option>
                      <option value="federal" data-id="element-195">Federal Agency</option>
                      <option value="fusion" data-id="element-196">Fusion Center</option>
                      <option value="corporate" data-id="element-197">Corporate Security</option>
                      <option value="other" data-id="element-198">Other</option>
                    </select>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-199">
                  <label className="text-sm font-mono text-iris-text uppercase" data-id="element-200">
                    Primary Use Case
                  </label>
                  <textarea required rows={3} className="w-full bg-iris-surface border border-iris-border px-4 py-3 text-white focus:outline-none focus:border-iris-green focus:ring-1 focus:ring-iris-green transition-colors resize-none" data-id="element-201"></textarea>
                </div>

                <div className="flex items-start gap-3 pt-2" data-id="element-202">
                  <input required type="checkbox" id="consent" className="mt-1 w-4 h-4 bg-iris-surface border-iris-border text-iris-green focus:ring-iris-green focus:ring-offset-iris-black" data-id="element-203" />
                  <label htmlFor="consent" className="text-xs text-iris-muted leading-relaxed" data-id="element-204">
                    I consent to having IRIS Intel Group store my submitted
                    information so they can respond to my inquiry. Information
                    is handled securely and never sold.
                  </label>
                </div>

                <Button type="submit" size="lg" className="w-full md:w-auto" data-id="element-205">
                  Request Walkthrough
                </Button>
              </form>}
          </div>

          <div className="lg:col-span-5 lg:pt-12" data-id="element-206">
            <div className="bg-iris-surface border border-iris-border p-8" data-id="element-207">
              <h3 className="font-mono text-iris-green uppercase tracking-widest mb-6 text-sm" data-id="element-208">
                {'// What Happens Next'}
              </h3>

              <div className="space-y-8" data-id="element-209">
                {[{
                num: '1',
                title: 'Confirmation',
                desc: 'We review your request and confirm eligibility within 1 business day.'
              }, {
                num: '2',
                title: 'Discovery Call',
                desc: "A brief 15-minute call to understand your agency's specific workflow challenges."
              }, {
                num: '3',
                title: 'Tailored Walkthrough',
                desc: 'A secure, customized platform walkthrough for your team.'
              }].map((step, i) => <div key={i} className="flex gap-4" data-id="element-210">
                    <div className="w-8 h-8 shrink-0 bg-iris-black border border-iris-border flex items-center justify-center font-mono text-sm text-iris-text" data-id="element-211">
                      {step.num}
                    </div>
                    <div data-id="element-212">
                      <h4 className="text-white font-bold mb-1" data-id="element-213">
                        {step.title}
                      </h4>
                      <p className="text-sm text-iris-muted" data-id="element-214">{step.desc}</p>
                    </div>
                  </div>)}
              </div>

              <div className="mt-10 pt-6 border-t border-iris-border" data-id="element-215">
                <p className="text-sm text-iris-muted" data-id="element-216">
                  Need immediate assistance? Email us at{' '}
                  <a href="mailto:deployments@irisintelgroup.com" className="text-iris-text hover:text-iris-green transition-colors" data-id="element-217">
                    deployments@irisintelgroup.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}